/**
 * Footer neon edge: the glowing hairline between the footer columns and the
 * copyright bar (same as the header's). Its colour sweep fades in when the line
 * scrolls into view and keeps flowing; it is paused again when off-screen.
 */
(() => {
  const edge = document.querySelector('.footer__edge');
  if (!edge) return;

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => edge.classList.toggle('is-playing', entry.isIntersecting));
    },
    { threshold: 0.5 }
  ).observe(edge);
})();
